import type { FC } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import type { StyleProp, ViewStyle } from 'react-native';
import { SvgIconType } from '@thermenresorts/icons';
import Colors from 'src/core/utils/Colors';
import Dimens from 'src/core/utils/Dimens';
import Fonts from 'src/core/utils/Fonts';
import Styles from 'src/core/utils/Styles';
import Translations from 'src/core/utils/Translations';
import SvgIcon from 'src/presentation/components/atoms/SvgIcon';
import { PrimaryButton } from 'src/presentation/components/molecules/Button';

interface Props {
	onPress: () => void;
	style?: StyleProp<ViewStyle>;
}

const ReserveVisitCard: FC<Props> = ({ onPress, style }) => {
	return (
		<View style={[styles.card, Styles.card.shadowSoft, style]}>
			<View style={styles.header}>
				<SvgIcon name={SvgIconType.calendarRounded} size={Dimens.iconSize16} tintColor={Colors.gray900} />
				<Text style={styles.heading}>{Translations.homeReserveVisit}</Text>
			</View>

			<PrimaryButton label={Translations.homeReserve} onPress={onPress} />
		</View>
	);
};

const styles = StyleSheet.create({
	card: {
		backgroundColor: Colors.white,
		borderRadius: Dimens.borderRadius4,
		padding: Dimens.padding20,
		gap: Dimens.gap16,
	},
	header: {
		flexDirection: 'row',
		alignItems: 'center',
		gap: Dimens.gap10,
	},
	heading: {
		flex: Dimens.flex1,
		color: Colors.gray900,
		fontFamily: Fonts.ptSerif,
		fontSize: Dimens.fontSize18,
		lineHeight: Dimens.lineHeight24,
	},
});

export default ReserveVisitCard;
